/**
 * Toggle theme values.
 */
import { Components } from "@oui/system/components"
import { css } from "@oui/system"
import palettes from "../../palettes"

// TODO: update to use transition animation tokens
const base = css`
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 26px;
  background-color: ${palettes.unavailable.main};
  border-radius: 10px;
  margin-left: 0;
  transition: 0.34s;
`

const appearances: Components["Switch"]["Toggle"]["appearances"] = {
  default: css`
    ${base};
    &:after {
      content: "";
      position: absolute;
      height: 22px;
      width: 22px;
      left: 2px;
      bottom: 2px;
      background-color: ${palettes.unavailable.text};
      border-radius: 8px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
      transition: 0.34s;
    }
  `
}

export default { appearances }
